import { AlertTriangle, Camera, RefreshCcw } from "lucide-react";
import { RECEPCION } from "@/constants/testIds";

export function CamaraEstado({ cam, onReintentar }) {
  return (
    <>
      {(cam.fase === "iniciando" || cam.fase === "verificando") && (
        <div
          data-testid={RECEPCION.cameraVerificando}
          className="absolute top-3 inset-x-3 z-10 flex items-center justify-center gap-2 rounded-full bg-black/60 text-white text-xs px-3 py-1.5"
        >
          <RefreshCcw className="w-3 h-3 animate-spin" strokeWidth={1.8} />
          {cam.fase === "iniciando" ? "Iniciando cámara…" : "Esperando imagen de la cámara…"}
        </div>
      )}
      {cam.aviso && cam.fase !== "error" && (
        <p
          data-testid={RECEPCION.cameraAviso}
          className="absolute bottom-3 inset-x-3 z-10 rounded-xl bg-amber-500/90 text-white text-[11px] leading-snug px-3 py-2 flex gap-2"
        >
          <AlertTriangle className="w-3.5 h-3.5 shrink-0" strokeWidth={1.8} />
          {cam.aviso}
        </p>
      )}
      {(cam.fase === "inactiva" || cam.fase === "error") && (
        <div
          data-testid={RECEPCION.cameraEstado}
          className="absolute inset-0 grid place-items-center p-6 text-center bg-muted"
        >
          <div className="max-w-xs">
            <div className="mx-auto mb-3 w-12 h-12 grid place-items-center rounded-2xl bg-accent/10 ring-1 ring-accent/30 text-accent">
              <Camera className="w-5 h-5" strokeWidth={1.6} />
            </div>
            {cam.fase === "error" ? (
              <>
                <p data-testid={RECEPCION.cameraError} className="text-sm text-red-600 dark:text-red-400">
                  {cam.error}
                </p>
                {cam.detalle && (
                  <p data-testid={RECEPCION.cameraDetalle} className="mt-2 text-[10px] text-muted-foreground break-words">
                    {cam.detalle}
                  </p>
                )}
                <button
                  type="button"
                  data-testid={RECEPCION.btnReintentarCamera}
                  onClick={onReintentar}
                  className="mt-4 inline-flex items-center justify-center gap-2 rounded-full px-4 min-h-[44px] text-xs font-medium bg-primary text-primary-foreground dark:bg-accent dark:text-accent-foreground hover:opacity-90 transition-opacity"
                >
                  <RefreshCcw className="w-3.5 h-3.5" strokeWidth={1.8} />
                  Reintentar
                </button>
              </>
            ) : (
              <p className="text-sm text-muted-foreground">
                Activa la cámara para escanear el código QR del boleto digital del asistente.
              </p>
            )}
          </div>
        </div>
      )}
    </>
  );
}
